import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=7156a3a8&scoped=true&"
import script from "./AboutUs.vue?vue&type=script&lang=js&"
export * from "./AboutUs.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=7156a3a8&lang=scss&scoped=true&"
import style1 from "./AboutUs.vue?vue&type=style&index=1&id=7156a3a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7156a3a8",
  null
  
)

export default component.exports